customElements.define(
  'product-modal',
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      this.closeLightbox();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      this.openLightbox(opener);
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      if (!activeMedia) return;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }

    buildLightbox() {
      if (this._lb) return;

      const section = this.id.replace('ProductModal-', '');
      const gallery = document.getElementById('MediaGallery-' + section);
      const mediaItems = gallery ? Array.from(gallery.querySelectorAll('.product__media-item')) : [];

      this._images = [];
      mediaItems.forEach((item) => {
        const img = item.querySelector('.product__media img, .product-media-container img');
        const mediaId = item.dataset.mediaId;
        if (img) {
          let src = img.src || img.currentSrc || '';
          src = src.replace(/&width=\d+/, '&width=1600').replace(/\?width=\d+/, '?width=1600');
          this._images.push({ src: src, alt: img.alt || '', mediaId: mediaId });
        }
      });

      if (this._images.length === 0) return;

      const lb = document.createElement('div');
      lb.className = 'gs-lb-overlay';
      lb.innerHTML = `
        <div class="gs-lb-backdrop"></div>
        <div class="gs-lb-box">
          <button class="gs-lb-close" aria-label="Close" type="button">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
          <div class="gs-lb-inner">
            <div class="gs-lb-main">
              <button class="gs-lb-nav gs-lb-prev" type="button" aria-label="Previous">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
              </button>
              <div class="gs-lb-img-wrap">
                <img class="gs-lb-img" src="" alt="" />
              </div>
              <button class="gs-lb-nav gs-lb-next" type="button" aria-label="Next">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
              </button>
              <div class="gs-lb-counter"></div>
            </div>
            <div class="gs-lb-thumbs">
              <div class="gs-lb-thumbs-inner"></div>
            </div>
          </div>
        </div>
      `;

      const thumbsInner = lb.querySelector('.gs-lb-thumbs-inner');
      this._images.forEach((img, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gs-lb-thumb';
        btn.dataset.index = i;
        btn.innerHTML = `<img src="${img.src.replace(/width=1600/, 'width=120')}" alt="${img.alt}" loading="lazy" />`;
        btn.addEventListener('click', () => this.lbGoTo(i));
        thumbsInner.appendChild(btn);
      });

      lb.querySelector('.gs-lb-backdrop').addEventListener('click', () => this.hide());
      lb.querySelector('.gs-lb-close').addEventListener('click', () => this.hide());
      lb.querySelector('.gs-lb-prev').addEventListener('click', () => this.lbGoTo(this._lbIndex - 1));
      lb.querySelector('.gs-lb-next').addEventListener('click', () => this.lbGoTo(this._lbIndex + 1));

      this._lbKeyHandler = (e) => {
        if (!this._lb || !this._lb.classList.contains('gs-lb-active')) return;
        if (e.key === 'ArrowLeft') this.lbGoTo(this._lbIndex - 1);
        if (e.key === 'ArrowRight') this.lbGoTo(this._lbIndex + 1);
        if (e.key === 'Escape') this.hide();
      };
      document.addEventListener('keydown', this._lbKeyHandler);

      document.body.appendChild(lb);
      this._lb = lb;
      this._lbIndex = 0;

      if (!document.getElementById('gs-lb-styles')) {
        const style = document.createElement('style');
        style.id = 'gs-lb-styles';
        style.textContent = `
          .gs-lb-overlay{display:none;position:fixed;inset:0;z-index:99999;align-items:center;justify-content:center}
          .gs-lb-overlay.gs-lb-active{display:flex}
          body.gs-lb-open{overflow:hidden}
          .gs-lb-backdrop{position:absolute;inset:0;background:rgba(0,0,0,0.78);cursor:pointer}
          .gs-lb-box{position:relative;z-index:1;background:#fff;border-radius:10px;box-shadow:0 12px 60px rgba(0,0,0,0.4);width:min(94vw,1080px);max-height:92vh;display:flex;flex-direction:column;overflow:hidden}
          .gs-lb-close{position:absolute;top:10px;right:10px;z-index:10;background:rgba(255,255,255,0.95);border:1px solid #ddd;border-radius:50%;width:38px;height:38px;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;box-shadow:0 2px 8px rgba(0,0,0,0.15);transition:background 0.15s}
          .gs-lb-close:hover{background:#f0f0f0}
          .gs-lb-inner{display:flex;height:min(84vh,680px)}
          .gs-lb-main{flex:1;position:relative;display:flex;align-items:center;justify-content:center;padding:28px 16px;background:#fff;overflow:hidden;min-width:0}
          .gs-lb-img-wrap{width:100%;height:100%;display:flex;align-items:center;justify-content:center}
          .gs-lb-img{max-width:100%;max-height:100%;object-fit:contain;display:block;transition:opacity 0.15s ease}
          .gs-lb-img.gs-lb-fade{opacity:0}
          .gs-lb-nav{position:absolute;top:50%;transform:translateY(-50%);background:rgba(255,255,255,0.95);border:1px solid #e0e0e0;border-radius:50%;width:42px;height:42px;display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:2;box-shadow:0 2px 10px rgba(0,0,0,0.12);transition:background 0.15s;padding:0;color:#222}
          .gs-lb-nav:hover{background:#f5f5f5}
          .gs-lb-nav:disabled{opacity:0.25;cursor:default;pointer-events:none}
          .gs-lb-prev{left:10px}
          .gs-lb-next{right:10px}
          .gs-lb-counter{position:absolute;bottom:10px;left:50%;transform:translateX(-50%);background:rgba(0,0,0,0.45);color:#fff;font-size:12px;line-height:1;padding:4px 12px;border-radius:20px;white-space:nowrap;pointer-events:none}
          .gs-lb-thumbs{width:108px;flex-shrink:0;background:#f7f7f7;border-left:1px solid #ececec;overflow-y:auto;overflow-x:hidden;padding:8px 6px}
          .gs-lb-thumbs::-webkit-scrollbar{width:3px}
          .gs-lb-thumbs::-webkit-scrollbar-thumb{background:#ccc;border-radius:2px}
          .gs-lb-thumbs-inner{display:flex;flex-direction:column;gap:6px}
          .gs-lb-thumb{width:100%;aspect-ratio:1;border:2px solid transparent;border-radius:5px;overflow:hidden;cursor:pointer;padding:2px;background:#fff;transition:border-color 0.15s;flex-shrink:0;display:block}
          .gs-lb-thumb img{width:100%;height:100%;object-fit:contain;display:block}
          .gs-lb-thumb:hover{border-color:#bbb}
          .gs-lb-thumb-active{border-color:#00a0b6!important;box-shadow:0 0 0 1px #00a0b6}
          @media(max-width:600px){
            .gs-lb-inner{flex-direction:column}
            .gs-lb-thumbs{width:100%;height:88px;border-left:none;border-top:1px solid #ececec;overflow-x:auto;overflow-y:hidden;padding:6px 8px;flex-shrink:0}
            .gs-lb-thumbs-inner{flex-direction:row;height:100%}
            .gs-lb-thumb{width:68px;height:68px;flex-shrink:0;aspect-ratio:unset}
            .gs-lb-box{width:98vw;max-height:96vh;border-radius:6px}
            .gs-lb-main{padding:12px 10px}
          }
        `;
        document.head.appendChild(style);
      }
    }

    lbGoTo(index) {
      const images = this._images;
      if (!images || index < 0 || index >= images.length) return;
      this._lbIndex = index;
      const imgEl = this._lb.querySelector('.gs-lb-img');
      const counter = this._lb.querySelector('.gs-lb-counter');
      const thumbs = this._lb.querySelectorAll('.gs-lb-thumb');
      const prevBtn = this._lb.querySelector('.gs-lb-prev');
      const nextBtn = this._lb.querySelector('.gs-lb-next');
      imgEl.classList.add('gs-lb-fade');
      setTimeout(() => {
        imgEl.src = images[index].src;
        imgEl.alt = images[index].alt;
        imgEl.classList.remove('gs-lb-fade');
      }, 150);
      thumbs.forEach((t) => t.classList.remove('gs-lb-thumb-active'));
      if (thumbs[index]) {
        thumbs[index].classList.add('gs-lb-thumb-active');
        thumbs[index].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      prevBtn.disabled = index === 0;
      nextBtn.disabled = index === images.length - 1;
      if (counter) counter.textContent = (index + 1) + ' / ' + images.length;
    }

    openLightbox(opener) {
      this.buildLightbox();
      if (!this._lb || !this._images.length) return;
      const clickedMediaId = opener.getAttribute('data-media-id');
      let startIndex = 0;
      if (clickedMediaId) {
        const found = this._images.findIndex(img => img.mediaId && img.mediaId.endsWith('-' + clickedMediaId));
        if (found > -1) startIndex = found;
      }
      this._lb.addEventListener('pointerup', (e) => e.stopPropagation(), { once: false });
      this._lb.classList.add('gs-lb-active');
      document.body.classList.add('gs-lb-open');
      this.lbGoTo(startIndex);
      setTimeout(() => { this.style.display = 'none'; }, 50);
    }

    closeLightbox() {
      if (this._lb) this._lb.classList.remove('gs-lb-active');
      document.body.classList.remove('gs-lb-open');
      this.style.display = '';
    }
  }
);